import React from 'react';
import {Button, Col, Form, Input, Row, Select} from "antd";
import {FormattedMessage, useIntl} from "react-intl";
import {CaretDownOutlined, SearchOutlined} from "@ant-design/icons";

interface SearchFormProps {
    keyword: string;
    setKeyword: Function;
    sortBy: string;
    setSortBy: Function;
    loadData: Function;
    entity?: string;
}

const SearchForm = ({entity, keyword, setKeyword, sortBy, setSortBy, loadData}: SearchFormProps) => {
    return (
        <Form layout="horizontal" className="mb-12" id="search-form">
            <Row gutter={16}>
                <Col flex={5}>
                    <Form.Item
                        name="keyword"
                        className={"dentobook-form-item"}
                    >
                        <Input value={keyword}
                               placeholder={useIntl().formatMessage({id: 'search'})}
                               onChange={e => {
                                   const value = e.target.value;

                                   setKeyword(value);
                                   loadData(true, sortBy, value);
                               }}
                               prefix={<SearchOutlined style={{fontSize: 24}}/>}
                        />
                    </Form.Item>
                </Col>
                <Col flex={0}>
                    <Form.Item name="sortBy"
                               className={"dentobook-form-item sort-by-input"}
                    >
                        <Select
                            size={"large"}
                            allowClear
                            value={sortBy}
                            suffixIcon={<CaretDownOutlined/>}
                            onChange={e => {
                                setSortBy(e);

                                loadData(true, e, keyword);
                            }}
                            placeholder={useIntl().formatMessage({id: 'sortBy'})}
                        >
                            <Select.Option value="name"><FormattedMessage id="name"/></Select.Option>
                            <Select.Option value="id">ID</Select.Option>
                            {entity !== 'medical' ?
                                <Select.Option value="lastHour"><FormattedMessage
                                    id="last_hour"/></Select.Option> : null}
                            {entity !== 'medical' ?
                                <Select.Option value="nextHour"><FormattedMessage
                                    id="next_hour"/></Select.Option> : null}

                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default SearchForm;
